<template>
  <v-container :class="containerClass" fluid>
    <classroom-form mode="edit" :classroom="classroom.data" @cancel="onCancel">
      <template #header>
        <div class="d-flex align-center">
          <v-btn
            icon
            color="primary"
            class="mr-2"
            :href="$route('classrooms.index')"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h2>Edit {{ classroom.data.name }}</h2>
        </div>
      </template>
    </classroom-form>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import ClassroomForm from '@components/Classroom/Form'
export default {
  components: {
    ClassroomForm,
  },
  layout: LayoutDashboard,
  props: {
    classroom: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onCancel() {
      window.location.href = this.$route('classrooms.index')
    },
  },
}
</script>
